<mat-drawer-container class="full-scroll" [class.full-scroll--video]="isVideoRoute">
    <!-- Side nav -->
    <mat-drawer class="panel-drawer" mode="side" [opened]="openMenu && !isVideoRoute">
        <div class="drawer-brand">
            <div class="drawer-brand__logo">
                <img alt="logo" src="./assets/img/logo_en_chiquito.png" />
            </div>
           
        </div>

        <nav class="panel-nav" aria-label="Navegación principal">
            <a [routerLink]="['home']" routerLinkActive="panel-nav__link--active" [routerLinkActiveOptions]="{ exact: true }" class="panel-nav__link">
                <mat-icon>home</mat-icon>
                <span>
                    <strong>Inicio</strong>
                </span>
            </a>

            <a [routerLink]="['booking']" routerLinkActive="panel-nav__link--active" class="panel-nav__link">
                <mat-icon>event_available</mat-icon>
                <span>
                    <strong>Sesiones</strong>
                </span>
            </a>

            <a [routerLink]="['settings']" routerLinkActive="panel-nav__link--active" class="panel-nav__link">
                <mat-icon>settings</mat-icon>
                <span>
                    <strong>Ajustes</strong>
                </span>
            </a>
        </nav>

        <div class="drawer-footer">
            <button type="button" class="drawer-logout" (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>
                    <strong>Salir</strong>
                </span>
            </button>
        </div>
    </mat-drawer>
    <mat-drawer-content>
        <!-- Navbar -->
        <mat-toolbar class="panel-toolbar fixed" *ngIf="!isVideoRoute">
            <button mat-icon-button class="toolbar-toggle" (click)="openMenu=!openMenu" [matTooltip]="'Mostrar/Ocultar menú'">
                <mat-icon *ngIf="!openMenu">menu</mat-icon>
                <mat-icon *ngIf="openMenu">menu_open</mat-icon>
            </button>

            <div class="toolbar-copy">
                <span class="toolbar-copy__eyebrow">Mindhelp</span>
                <h3 class="dmsans hide-on-non-phone">{{ titleNav }}</h3>
            </div>

            <div class="toolbar-status">
                <span class="toolbar-status__dot"></span>
                <span>Sesión activa</span>
            </div>
        </mat-toolbar>
        <!-- Aplication -->
        <section class="content-app">
            <router-outlet></router-outlet>
        </section>
    </mat-drawer-content>
</mat-drawer-container>

<div class="loading" *ngIf="showGlobalLoading" >
    <mat-spinner></mat-spinner>
</div>
